const ANGULAR_SPEED = 150;
const LINEAR_SPEED = 250;
const ARROW = "arrow";
const ARROW_POINTER = "arrowPointer";
const BAR_POINTER = "barPointer";
const DEFAULT_HEIGHT = 200;
const DEFAULT_LINE_WIDTH = 0.5;
const DEFAULT_WIDTH = 200;
const DEGREE = Math.PI / 180;
const INSIDE = "inside";
const LINEAR = "linear";
const OUTSIDE = "outside";
const RADIAL_POINTER = "radialPointer";
const RADIAL_RANGE_POINTER = "radialRangePointer";

export {
    ANGULAR_SPEED, LINEAR_SPEED, ARROW, ARROW_POINTER, BAR_POINTER,
    DEFAULT_HEIGHT, DEFAULT_LINE_WIDTH, DEFAULT_WIDTH,
    DEGREE, INSIDE, LINEAR, OUTSIDE, RADIAL_POINTER, RADIAL_RANGE_POINTER
};